export default __webpack_public_path__ + "static/media/7.17.066c6003.mp3";